import useApi from './api'

const useSaveProbateEstateField = ({
  probateEstateId,
}: {
  probateEstateId: number
}) => {
  const [
    {
      data: updatedProbateEstate,
      isLoading: isEstateUpdating,
      errors: estateErrors,
    },
    updateProbateEstate,
  ] = useApi()

  const saveProbateEstateField = ({
    name,
    value,
  }: {
    name: string
    value: unknown
  }) => {
    updateProbateEstate({
      url: `/api/probate-estates/${probateEstateId}`,
      method: 'PATCH',
      data: {
        data: {
          type: 'probate_estates',
          id: probateEstateId,
          attributes: { [name]: value || null },
        },
      },
      // avoids an unhandled promise rejection; estateErrors covers this
    }).catch(() => undefined)
  }

  return {
    saveProbateEstateField,
    updatedProbateEstate,
    isEstateUpdating,
    estateErrors,
  }
}

export default useSaveProbateEstateField
